export default {
    loading: false,
    error: null,
    usuario: {nome: '', unidade: ''},
    usuarioGestao: false,
    captcha: null,
    wsAtivo: null
};
